import { io } from "socket.io-client";
import { getLocalStorage, dataLocalStorage } from "src/helper/publicFunction";

let socketInstance = null;

/**
 * Get or create Socket.IO instance
 * @param {string} apiUrl - API base URL
 * @returns {Socket} Socket.IO instance
 */
export const getSocket = (apiUrl) => {
  console.log("🔌 getSocket called with apiUrl:", apiUrl);

  if (socketInstance?.connected) {
    console.log("✅ Using existing connected socket:", socketInstance.id);
    return socketInstance;
  }

  const userData = getLocalStorage(dataLocalStorage.userinfo);
  const token = userData?.token;

  console.log("🔑 Token check:", {
    hasUserData: !!userData,
    hasToken: !!token,
    tokenPrefix: token ? token.substring(0, 20) + "..." : "N/A",
  });

  if (!token) {
    console.error("❌ No token found for socket connection");
    return null;
  }

  console.log("🚀 Creating new socket instance...");
  console.log("📡 Connecting to:", apiUrl);

  socketInstance = io(apiUrl, {
    auth: {
      token: `Bearer ${token}`,
    },
    transports: ["websocket", "polling"],
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionAttempts: 5,
    forceNew: true,
  });

  socketInstance.on("connect", () => {
    console.log("✅ Socket connected:", socketInstance.id);
  });

  socketInstance.on("disconnect", (reason) => {
    console.log("❌ Socket disconnected:", reason);
  });

  socketInstance.on("connect_error", (error) => {
    console.error("❌ Socket connection error:", error);
    console.error("Error details:", {
      message: error.message,
      description: error.description,
      context: error.context,
      type: error.type,
    });
  });

  socketInstance.io.on("error", (error) => {
    console.error("❌ Socket.IO engine error:", error);
  });

  socketInstance.io.on("reconnect_attempt", (attempt) => {
    console.log(`🔄 Reconnection attempt ${attempt}...`);
  });

  socketInstance.io.on("reconnect_failed", () => {
    console.error("❌ Failed to reconnect after all attempts");
  });

  return socketInstance;
};

/**
 * Disconnect socket instance
 */
export const disconnectSocket = () => {
  if (socketInstance) {
    socketInstance.disconnect();
    socketInstance = null;
  }
};

/**
 * Check if socket is connected
 * @returns {boolean}
 */
export const isSocketConnected = () => {
  return socketInstance?.connected || false;
};
